<script>
//import axios from 'axios'

import ProjectSearch from "./projectSearchEngine/index.vue";

export default {
  components: {
    ProjectSearch
  },
  data() {
    return {
      
    }
  },

  methods: {

  },
}
</script>

<template>
  <div id="app" style="width: 100%; height: 100%; overflow: auto;">

    <project-search></project-search>

  </div>
</template>

<style lang="scss" scoped>
  
</style>
